/* eslint-disable sonarjs/no-useless-catch */
 
 
import { AxiosInstance, AxiosResponse } from 'axios';

import axios from './axios';
import { setAccessToken } from './services';
import { fetchAndStoreConfig, fetchConfig } from '../utils/configUtils';
import { POST, configKey, configPath } from '../utils/constant';

const setConfigUrl = (
  apimPath: string,
  endpoint: string,
  configData: any,
): string => {
  let url = '';
  if (endpoint) {
    const configUrl = configData[endpoint];
    if (configUrl && configUrl !== undefined) url = configUrl;
  }
  if (apimPath) {
    const configUrl = configData[apimPath];
    if (configUrl && configUrl !== undefined) url = `${configUrl}${url}`;
  }
  return url;
};

// n to make an API call using config data from session storage
export const makeApiCall = async (
  apimPath: string,
  endpoint: string,
  method: 'GET' | 'POST' = 'GET',
  data = null,
  instance: AxiosInstance = axios,
): Promise<AxiosResponse<any, any>> => {
  let configData = fetchConfig(configKey);
  if (!configData) {
    // If config data is not in session storage, fetch and store it
    await fetchAndStoreConfig(configPath, configKey);
    configData = fetchConfig(configKey);
  }

  const url = setConfigUrl(apimPath, endpoint, configData);

   
  try {
    return await instance({
      method,
      url,
      data,
    });
  } catch (error) {
    const originalRequest = error.config;
    if (
      (error.response.status === 403 || error.response.status === 401) &&
      originalRequest.headers['x-lbg-access-token']
    ) {
      try {
        const payload = {
          RefreshToken: sessionStorage.getItem('REFRESH_TOKEN'),
        };
        const res = await makeApiCall(
          'OTP_VERIFICATION_API_HOST_PATH',
          'REFRESH_TOKEN_ENDPOINT',
          POST,
          payload,
        );
        if (res.status === 200) {
          setAccessToken(res.data.AccessToken);
          // Update the original request with the new token
          originalRequest.headers['x-lbg-access-token'] = res.data.accessToken;
          // Retry the original request
          return await instance(originalRequest);
        }
      } catch (refreshError) {
        throw error;
      }
    } else {
      throw error;
    }
  }
};

export const getBusinessDetails = (
  payload?: any,
): Promise<AxiosResponse<any, any>> =>
  makeApiCall('API_HOST_PATH', 'IDENTIFY_BUSINESS_ENDPOINT', POST, payload);

export const getIndividualDetails = (
  payload?: any,
): Promise<AxiosResponse<any, any>> =>
  makeApiCall('API_HOST_PATH', 'INDIVIDUAL_DETAILS_ENDPOINT', POST, payload);

export const submitRegistrationDetails = (
  payload?: any,
): Promise<AxiosResponse<any, any>> =>
  makeApiCall('API_HOST_PATH', 'SUBMIT_REGISTRATION_ENDPOINT', POST, payload);

export const getJwtToken = (
  payload?: any,
): Promise<AxiosResponse<{ jwt: string }>> =>
  makeApiCall('API_HOST_PATH', 'JWT_TOKEN_ENDPOINT', POST, payload);

export const otpVerificationInit = (
  payload?: any,
): Promise<AxiosResponse<any, any>> =>
  makeApiCall(
    'OTP_VERIFICATION_API_HOST_PATH',
    'OTP_VERIFICATION_ENDPOINT',
    POST,
    payload,
  );

export const fetchAccessTokenDetails = (
  payload?: any,
): Promise<AxiosResponse<any, any>> =>
  makeApiCall(
    'OTP_VERIFICATION_API_HOST_PATH',
    'FETCH_ACCESS_TOKEN_ENDPOINT',
    POST,
    payload,
  );
